import type { FormSchema, Schema } from '@cli-types/core-engine/schema.js'
import type { DevModeSchemaType } from '@cli-types/next-adapter/generators.js'
export function createSchemaJsonImportPath(
  schema: Schema | FormSchema,
  schemaType: DevModeSchemaType,
  adminImportAlias: string
): string {
  const schemaDir = schemaType === 'form' ? 'schemas/forms' : 'schemas'
  return `${adminImportAlias}/${schemaDir}/${schema.name}.json`
}
